export default __webpack_public_path__ + "static/tag-dont-1-dark-6176d20ca55f5c77d0873db459898b73be7f5dce433b5d0fcd2d5548c2ee3fbf.png";